import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useUser } from '../../userContext';

function SettingsSidebar() {

  const location = useLocation();
  const { pathname } = location;
  const { subscriptionType } = useUser();

  const isAgencyPlan = subscriptionType === 'agency';

  return (
    <div className="flex flex-col md:block px-3 py-6 border-b md:border-b-0 md:border-r min-w-[15rem] md:space-y-3 overflow-visible" style={{
      borderColor: 'rgba(241, 196, 15, 0.3)',
      fontFamily: '"Share Tech Mono", monospace'
    }}>
      {/* Fixed Settings text */}
      <div className="px-2.5 mb-3">
        <div className="text-xs font-bold uppercase tracking-wider" style={{
          color: '#F1C40F',
          textShadow: '0 0 4px rgba(241, 196, 15, 0.3)'
        }}>
          SETTINGS
        </div>
      </div>
      
      {/* Scrollable navigation */}
      <div className="overflow-x-auto overflow-visible no-scrollbar">
        <ul className="flex md:block mr-3 md:mr-0 min-w-max">
          <li className="mr-0.5 md:mr-0 md:mb-0.5">
            <NavLink 
              end 
              to="/studio/settings/account" 
              className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap transition-all duration-100 ${
                pathname.includes('/settings/account') 
                  ? 'shadow-md' 
                  : ''
              }`}
              style={pathname.includes('/settings/account') ? {
                background: 'linear-gradient(135deg, #F1C40F, #F39C12)',
                color: '#2C3E50',
                textShadow: '1px 1px 0px #E67E22'
              } : {
                color: '#BDC3C7'
              }}
              onMouseEnter={(e) => {
                if (!pathname.includes('/settings/account')) {
                  e.target.style.background = 'rgba(241, 196, 15, 0.1)';
                  e.target.style.color = '#F1C40F';
                }
              }}
              onMouseLeave={(e) => {
                if (!pathname.includes('/settings/account')) {
                  e.target.style.background = 'transparent';
                  e.target.style.color = '#BDC3C7';
                }
              }}
            >
              <svg className="shrink-0 fill-current mr-2" width="16" height="16" viewBox="0 0 16 16" style={{
                color: pathname.includes('/settings/account') ? '#2C3E50' : '#F1C40F'
              }}>
                <path d="M8 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-5.143 7.91a1 1 0 1 1-1.714-1.033A7.996 7.996 0 0 1 8 10a7.996 7.996 0 0 1 6.857 3.877 1 1 0 1 1-1.714 1.032A5.996 5.996 0 0 0 8 12a5.996 5.996 0 0 0-5.143 2.91Z" />
              </svg>
              <span className="text-sm font-bold">ACCOUNT</span>
            </NavLink>
          </li>
          <li className="mr-0.5 md:mr-0 md:mb-0.5">
            <NavLink 
              end 
              to="/studio/settings/company" 
              className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap transition-all duration-100 ${
                pathname.includes('/settings/company') 
                  ? 'shadow-md' 
                  : ''
              }`}
              style={pathname.includes('/settings/company') ? {
                background: 'linear-gradient(135deg, #F1C40F, #F39C12)',
                color: '#2C3E50',
                textShadow: '1px 1px 0px #E67E22'
              } : {
                color: '#BDC3C7'
              }}
              onMouseEnter={(e) => {
                if (!pathname.includes('/settings/company')) {
                  e.target.style.background = 'rgba(241, 196, 15, 0.1)';
                  e.target.style.color = '#F1C40F';
                }
              }}
              onMouseLeave={(e) => {
                if (!pathname.includes('/settings/company')) {
                  e.target.style.background = 'transparent';
                  e.target.style.color = '#BDC3C7';
                }
              }}
            >
              <svg 
                className="shrink-0 fill-current mr-2" 
                width="16" 
                height="16" 
                viewBox="0 0 24 24"
                style={{
                  color: pathname.includes('/settings/company') ? '#2C3E50' : '#F1C40F'
                }}
              >
                <path d="M3 21h18v-2H3v2zm4-4h10v-2H7v2zm0-4h10v-2H7v2zm0-4h10V7H7v2zm-4 8h18v-2H3v2zm0-16v2h18V3H3z"/>
              </svg>
              <span className="text-sm font-bold">COMPANY</span>
            </NavLink>
          </li>
          <li className="mr-0.5 md:mr-0 md:mb-0.5">
            <NavLink 
              end 
              to="/studio/settings/plans" 
              className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap transition-all duration-100 ${
                pathname.includes('/settings/plans') 
                  ? 'shadow-md' 
                  : ''
              }`}
              style={pathname.includes('/settings/plans') ? {
                background: 'linear-gradient(135deg, #F1C40F, #F39C12)',
                color: '#2C3E50',
                textShadow: '1px 1px 0px #E67E22'
              } : {
                color: '#BDC3C7'
              }}
              onMouseEnter={(e) => {
                if (!pathname.includes('/settings/plans')) {
                  e.target.style.background = 'rgba(241, 196, 15, 0.1)';
                  e.target.style.color = '#F1C40F';
                }
              }}
              onMouseLeave={(e) => {
                if (!pathname.includes('/settings/plans')) {
                  e.target.style.background = 'transparent';
                  e.target.style.color = '#BDC3C7';
                }
              }}
            >
              <svg className="shrink-0 fill-current mr-2" width="16" height="16" viewBox="0 0 16 16" style={{
                color: pathname.includes('/settings/plans') ? '#2C3E50' : '#F1C40F'
              }}>
                <path d="M5 9a1 1 0 1 1 0-2h6a1 1 0 0 1 0 2H5ZM1 4a1 1 0 1 1 0-2h14a1 1 0 0 1 0 2H1Zm0 10a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2H1Z" />
              </svg>
              <span className="text-sm font-bold">PLANS</span>
            </NavLink>
          </li>
          <li className="mr-0.5 md:mr-0 md:mb-0.5">
            {isAgencyPlan && (
              <NavLink 
                end 
                to="/studio/settings/users" 
                className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap transition-all duration-100 ${
                  pathname.includes('/settings/users') 
                    ? 'shadow-md' 
                    : ''
                }`}
                style={pathname.includes('/settings/users') ? {
                  background: 'linear-gradient(135deg, #F1C40F, #F39C12)',
                  color: '#2C3E50',
                  textShadow: '1px 1px 0px #E67E22'
                } : {
                  color: '#BDC3C7'
                }}
                onMouseEnter={(e) => {
                  if (!pathname.includes('/settings/users')) {
                    e.target.style.background = 'rgba(241, 196, 15, 0.1)';
                    e.target.style.color = '#F1C40F';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!pathname.includes('/settings/users')) {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#BDC3C7';
                  }
                }}
              >
                <svg 
                  className="shrink-0 fill-current mr-2" 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24"
                  style={{
                    color: pathname.includes('/settings/users') ? '#2C3E50' : '#F1C40F'
                  }}
                >
                  <path d="M12 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm6 10a1 1 0 0 0 1-1 7 7 0 0 0-14 0 1 1 0 0 0 1 1zm-6-3a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm8-4a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm4.5 6a.5.5 0 0 0 .5-.5 5.5 5.5 0 0 0-11 0 .5.5 0 0 0 .5.5z"/>
                </svg>
                <span className="text-sm font-bold">USERS</span>
              </NavLink>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SettingsSidebar;
